import {
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
    Heading,
} from '@pzh-ui/components'
import clsx from 'clsx'

import {
    PublicationAnnouncementShort,
    PublicationEnvironment,
    PublicationPackage,
    PublicationShort,
    PublicationVersion,
} from '@/api/fetchers.schemas'

import { PublicationType } from '../types'
import AnnouncementData from './components/AnnouncementData'
import { ActPackages, AnnouncementPackages } from './components/Packages'

const config = {
    act: {
        label: 'Regeling',
        component: ActPackages,
    },
    announcement: {
        label: 'Kennisgeving',
        component: AnnouncementPackages,
    },
}

interface PublicationPackagesProps {
    environment?: PublicationEnvironment
    version: PublicationVersion
    publication?: PublicationShort
    publicationType: PublicationType
    validPublicationPackage?: PublicationPackage
    announcement?: PublicationAnnouncementShort
    isLocked?: boolean
    isClosed?: boolean
    isDisabled?: boolean
}

const PublicationPackages = ({
    environment,
    publicationType,
    version,
    announcement,
    isDisabled,
    isClosed,
    ...rest
}: PublicationPackagesProps) => {
    const Packages = config[publicationType].component

    return (
        <AccordionItem
            value={publicationType}
            disabled
            className={clsx('group border-pzh-gray-200 rounded-lg border', {
                'bg-pzh-gray-100': version.Is_Locked,
            })}>
            <AccordionTrigger
                hideIcon
                className={clsx(
                    'bg-pzh-gray-100 flex h-16 items-center justify-between rounded-t-lg px-6 group-only:hover:cursor-default group-only:hover:no-underline hover:[&[data-disabled]]:no-underline [&[data-state=closed]]:rounded-b-lg [&[data-state=open]>svg]:rotate-90',
                    {
                        '[&[data-disabled]>*]:text-pzh-gray-300': isDisabled,
                    }
                )}>
                <Heading level="3" size="m" className="capitalize">
                    {config[publicationType].label}
                </Heading>
            </AccordionTrigger>
            <AccordionContent className="pb-0">
                {publicationType === 'announcement' && !!announcement && (
                    <AnnouncementData
                        isLocked={isDisabled}
                        isClosed={isClosed}
                        {...announcement}
                        {...rest}
                    />
                )}
                {environment?.Can_Validate && (
                    <Packages
                        version={version}
                        publicationType={publicationType}
                        packageType="validation"
                        customLabel={
                            !environment.Can_Publicate
                                ? 'Publicatie'
                                : undefined
                        }
                        environment={environment}
                        isLocked={isDisabled}
                        isClosed={isClosed}
                        {...rest}
                    />
                )}
                {environment?.Can_Publicate && (
                    <Packages
                        version={version}
                        publicationType={publicationType}
                        packageType="publication"
                        environment={environment}
                        isLocked={isDisabled}
                        isClosed={isClosed}
                        {...rest}
                    />
                )}
            </AccordionContent>
        </AccordionItem>
    )
}

export default PublicationPackages
